<template>
  <div class="sku-tips" v-show="rebate.rebate * 1">
    <span>返{{rebate.rebate}}</span>
  </div>
</template>

<script>
export default {
  name: 'skuRewardsTips',
  props: ['sku'],
  computed: {
    rebate () {
      return this.sku.activity || this.sku.equity
    }
  }
}
</script>

<style lang="less" scoped>
.sku-tips {
  display: flex;
  font-size: @fz20;
  color: @price;
  white-space: nowrap;
  span {
    padding: 0 0.1rem;
    height: 0.38rem;
    background-color: #ffeaef;
    border-radius: 30px;
    .flex-center;
  }
}
</style>
